/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';

export const opportunityCollaboratorsDtoSchema = z.object({ "collaboratorId": z.string().uuid().nullish() });
export type OpportunityCollaboratorsDto = z.infer<typeof opportunityCollaboratorsDtoSchema>;
